import {Center as MantineCenter} from '@mantine/core';

/**
 * Centering container — design-layer pass-through over Mantine `Center`.
 * @registry Pass-through Mantine Center; import this instead of @mantine/core outside src/design.
 */
export const Center = MantineCenter;
